<template>
  <div class="w-full">
    <div
      class="relative border-1 rounded-2xl min-w-full min-h-[60vh] 2xl:min-h-[80vh] flex flex-col gap-2 px-2 pt-4 pb-5 border-gray-300"
>
      <div
        class="mobile:w-[90%] mobile:right-0 mobile:left-0 laptop:w-4/5 desktop:w-3/5 largeDesktop:w-3/6 mx-auto flex tablet:justify-end  items-center gap-2 absolute -top-6 tablet:right-6 tablet:left-auto"
>
        <entities :model-value="limit" global-entities-class="'tablet:w-[45%]'" @update:model-value="onLimitChange" />
        <searchInput
v-model="search"
          :global-search-class="'mobile:w-full tablet:!w-[55%]'"
          :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none text-sm'" :buttonclass="'absolute top-1.5 right-1 w-7 h-7'"
          :img-src="require('@/assets/images/search-icon.png')"
          :clear-class="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'" :on-clear="onClearSearch" :readonly="loading" :clearable="true" @input="onSearch"
/>
      </div>
      <div class="mx-auto absolute -top-6 right-4">
        <createQoute />
      </div>
      <div v-if="list.length > 0" class="mt-2 min-h-[50vh]">
        <listings v-for="(item, index) in list" :key="index" :item="item" @click="itemClicked(item)" />
      </div>
      <div v-else>
        <EmptyState v-if="addresses == null || (addresses && addresses.length == 0)" />
      </div>
    </div>
    <div
      class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3"
>
      <paginationEntries
class="mobile:hidden tablet:block" :current-page="page" :per-page="limit"
        :total-items="totalItems"
/>
      <customPagination :page="page" :total_pages="total_pages" :update-page="updatePage" />
    </div>
  </div>

  <!-- Contractor Modal Modal -->
  <div
id="contractorModal" ref="contractorModal" class="modal fade" tabindex="-1" aria-labelledby="contractorModal"
    aria-hidden="true"
>
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full"
>
      <div class="modal-content select-none">
        <div class="modal-body !p-3 !pb-5">
          <div
            class="relative w-full mobile:h-[70px] tablet:h-[100px] rounded-lg overflow-hidden flex items-center justify-start"
>
            <button
type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close"
>
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <img
src="../../assets/images/profile-bg.png" class="w-full object-contain absolute left-0 top-0"
                alt="backgroundImage"
>
              <div class="relative flex justify-between items-center w-full z-10 ps-3 !pe-12">
                <h6 class="m-0 text-xl font-roboto font-semibold text-black-100">
                  Details
                </h6>
                <img
:src="planDetails && planDetails.partner_company_logo" alt="contractor Logo"
                  class="w-14 h-14 object-contain"
>
              </div>
            </div>
          </div>
          <div
            class="mobile:max-h-[90vh] desktop:max-h-[70vh] largeDesktop:max-h-[90vh] overflow-y-auto customScrollbar mobile:mt-2 tablet:mt-4"
>
            <companyDetailDropdown :item="planDetails" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyState from "@/components/partialComponent/EmptyState.vue";
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import listings from "../../components/listings/Listings.vue";
import searchInput from '../../components/partialComponent/customInput.vue';
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import createQoute from "../../components/createQuote/createQuote.vue";
import companyDetailDropdown from "../../components/companyDetailModal.vue"
import entities from "../../components/showEntities/entities.vue";
export default {
  components: { EmptyState,
    listings,
    searchInput,
    createQoute,
    customPagination,
    companyDetailDropdown,
    entities,
    paginationEntries
  },
  data() {
    return {
      limit: 25,
      search: "",
      page: 1,
      total_pages: 0,
      totalItems: 0,
      list: [],
      planDetails: null,
      debounceTimer: null,
      loading: false
    };
  },
  computed: {
    ...mapGetters([
      "protectionPlanSalesListing",
      "salesPlanDetails"
    ]),
  },
  watch: {
    protectionPlanSalesListing: function (data) {
      this.loading = false
      this.list = this.protectionPlanSalesListing.body
      this.total_pages = this.protectionPlanSalesListing.paging.total_pages
      this.totalItems = this.protectionPlanSalesListing.paging.total_records
    },

    salesPlanDetails: function (data) {
      this.planDetails = this.salesPlanDetails
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.contractorModal;
      this.Modal = Modal.getInstance(modalEl);
      if (!this.Modal) {
        this.Modal = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      }
      modalEl.addEventListener('show.bs.modal', () => {
        document.documentElement.style.overflow = 'hidden'; // Target HTML element
        if (window.innerWidth >= 992) {
          document.documentElement.style.paddingRight = '15px';
        } else {
          document.documentElement.style.paddingRight = '0px';
        }
      });
      modalEl.addEventListener('hidden.bs.modal', () => {
        document.documentElement.style.overflow = ''; // Reset HTML element
        document.documentElement.style.paddingRight = '0px';
      });
      this.Modal.show();
    },

    protectionPlanDetails: function (data) {
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.protectionPlanDetailModal;

      this.modal = Modal.getInstance(modalEl);
      if (!this.modal) {
        this.modal = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      }
      // Add event listeners for show/hide
      modalEl.addEventListener('show.bs.modal', () => {
        document.documentElement.style.overflow = 'hidden'; // Target HTML element
        if (window.innerWidth >= 992) {
          document.documentElement.style.paddingRight = '15px';
        } else {
          document.documentElement.style.paddingRight = '0px';
        }
      });

      modalEl.addEventListener('hidden.bs.modal', () => {
        document.documentElement.style.overflow = ''; // Reset HTML element
        document.documentElement.style.paddingRight = '0px';
      });

      this.modal.show();
      this.$refs.protectionPlanDetailModal.addEventListener('hidden.bs.modal', this.onCartModalClose);
    },
  },
  mounted() {

    const is_from_mobile = localStorage.getItem("is_from_mobile", 0) ?? 0
    // if (is_from_mobile == '1') {
    //   this.$router.replace({
    //     name:'success',
    //     query: {
    //         redirect_to: 'plan_purchased',
    //         is_from_mobile: is_from_mobile
    //       },
    //   })
    // } else {
      this.loading = true
      this.getprotectionPlanSalesListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page
      });
    //}
  },
  methods: {
    ...mapActions([
      "getprotectionPlanSalesListing",
      "getSalesPlanDetails"
    ]),
    itemClicked(data) {
      this.getSalesPlanDetails({
        id: data.id
      })
    },
    updatePage(page) {
      if (page == this.page) return
      this.page = page
      this.loading = true
      this.getprotectionPlanSalesListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page
      });
       this.$nextTick(() => {
                document.documentElement.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            });
    },
    onSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.debounceTimer = setTimeout(() => {
        if (this.search.length == 0 || this.search.trim().length > 0) {
          this.loading = true
          this.getprotectionPlanSalesListing({
            "search": this.search,
            "limit": this.limit,
            "page": this.page
          });
        }
      }, 1000); // 1200ms delay
    },
    onClearSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.search = ''
      this.loading = true
      this.getprotectionPlanSalesListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page
      });

    },
    onLimitChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.loading = true;
      this.getprotectionPlanSalesListing({
        search: this.search,
        limit: this.limit,
        page: this.page,
      });
    }
  },
};
</script>
